export class unavailablesReceived {
    constructor(unavailableJson) {
        this.unavailableId          = unavailableJson.TypeNotReadyId;        	
        this.unavailableName		= unavailableJson.Description;        	
        this.frame		            = unavailableJson.Frame;        	
        this.max		            = unavailableJson.Max;        	
        this.unavailableRestricted	= unavailableJson.NotReadyRestricted;        	
        this.numberOfEvents		    = unavailableJson.NumberOfEvents;     
    }
}